<div class="bg-white">
    <div class="container bg-white py-3">
        <div class="row py-3">
           <!-- <app-breadcrumb-two></app-breadcrumb-two>-->
            <app-breadcrumb-two [historyItems]="historyItems"></app-breadcrumb-two>
        </div>
        <div class="row">
            <div class="col-12 col-md-3">
                <div class="row">
                    <div class="col-12 col-md-5 px-0">
                        <div class="profile-image">
                            <img class="image-profile" *ngIf="user?.profilePhotoUrl" [src]="user?.profilePhotoUrl"
                                alt="">
                            <img class="image-profile" *ngIf="!user?.profilePhotoUrl"
                                src="../../../../assets/images/avatar.png" alt="">
                        </div>
                    </div>
                    <div class="col-12 col-md-7 px-0 primary-data">
                        <h5>{{ user?.User.firstName }} <br> {{ user?.User.lastName }}</h5>
                        <span *ngIf="user?.profile?.position">Dirección de Desarrollo, Inovación y Gobierno
                            Abierto</span>
                    </div>
                </div>
                <div class="">
                    <nav>
                        <ul class="primary-menu">
                            <li class="menu-item" [ngClass]="{ 'active': location === 'Data' }"
                                (click)="onChangeLocation('Data')">Mis Datos</li>
                            <li class="menu-item" [ngClass]="{ 'active': location === 'Expediente' }"
                                (click)="onChangeLocation('Expediente')">Mi Expediente Electrónico</li>
                            <li class="menu-item" [ngClass]="{ 'active': location === 'Tramites' }"
                                (click)="onChangeLocation('Tramites')">Mis Trámites</li>
                        </ul>
                        <ul class="secondary-menu">
                            <li class="menu-item" [ngClass]="{ 'active': location === 'Password' }"
                                (click)="onChangeLocation('Password')">Cambiar contraseña</li>
                            <li class="menu-item" (click)="logout()">Cerrar sesión</li>
                        </ul>
                    </nav>
                </div>
            </div>


            <div class="col-12 col-md-9">
                <app-data *ngIf="location === 'Data'" [id]="userId" class="w-100"></app-data>
                <app-record-documents *ngIf="location === 'Expediente'" [id]="userId"
                    class="w-100"></app-record-documents>
                <app-list-tramites *ngIf="location === 'Tramites'" [id]="userId" [location]="location" class="w-100"></app-list-tramites>

                <!-- ── Cambiar contraseña ─────────────────────────────── -->
                <div *ngIf="location === 'Password'" class="password-section">
                    <h4 class="section-title mb-4">Cambiar contraseña</h4>

                    <div class="password-card">
                        <form [formGroup]="formpassword" (ngSubmit)="onChangePassword()" novalidate>

                            <div class="form-group mb-3">
                                <label class="field-label">Nueva contraseña <span class="text-danger">*</span></label>
                                <input type="password"
                                       class="form-control field-input"
                                       formControlName="password"
                                       placeholder="Mínimo 8 caracteres"
                                       autocomplete="new-password">
                                <div *ngIf="submitted && formStatePass['password'].errors" class="field-error mt-1">
                                    <span *ngIf="formStatePass['password'].errors['required']">La contraseña es requerida.</span>
                                    <span *ngIf="formStatePass['password'].errors['minlength']">Mínimo 8 caracteres.</span>
                                </div>
                            </div>

                            <div class="form-group mb-4">
                                <label class="field-label">Confirmar contraseña <span class="text-danger">*</span></label>
                                <input type="password"
                                       class="form-control field-input"
                                       formControlName="confirmedPassword"
                                       placeholder="Repite la contraseña"
                                       autocomplete="new-password">
                                <div *ngIf="submitted && formStatePass['confirmedPassword'].errors" class="field-error mt-1">
                                    <span *ngIf="formStatePass['confirmedPassword'].errors['required']">Confirma tu contraseña.</span>
                                    <span *ngIf="formStatePass['confirmedPassword'].errors['incorrect']">Las contraseñas no coinciden.</span>
                                </div>
                            </div>

                            <div class="d-flex justify-content-end">
                                <button type="button" class="btn-cancel mr-3"
                                        (click)="onChangeLocation('Data')">Cancelar</button>
                                <button type="submit" class="btn-save" [disabled]="isLoading">
                                    <span *ngIf="!isLoading">Actualizar contraseña</span>
                                    <span *ngIf="isLoading">Guardando...</span>
                                </button>
                            </div>

                        </form>
                    </div>
                </div>

            </div>
        </div>
    </div>
    
</div>